'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/react-outside-click-handler/~/has/src/index.js
// module id = 1099
// module chunks = 0